import { useTranslation } from 'react-i18next';
import { S, Icon, BtnSecondary, DataCard } from '../regureStyles';

const SLIDING_SCALE = [
  { lossBand: '0–40%', commission: 15.0 },
  { lossBand: '40–55%', commission: 13.5 },
  { lossBand: '55–70%', commission: 12.0 },
  { lossBand: '70–85%', commission: 10.0 },
  { lossBand: '85%+', commission: 8.0 },
];

const SlidingScale = () => {
  const { t } = useTranslation();
  const headers = [
    t('screens.commissions.scaleColBand'),
    t('screens.commissions.scaleColRate'),
    t('screens.commissions.scaleColStatus'),
  ];
  return (
    <div>
      <div style={{ fontSize: 14, color: S.textSecondary, marginBottom: 20, maxWidth: 560 }}>
        {t('screens.commissions.scaleIntro')}
      </div>
      <DataCard style={{ maxWidth: 560 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: S.textPrimary, marginBottom: 16 }}>{t('screens.commissions.scaleTitle')}</div>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {headers.map(h => (
                <th
                  key={h}
                  style={{
                    padding: '10px 14px',
                    textAlign: 'left',
                    fontSize: 11,
                    fontWeight: 700,
                    color: S.textMuted,
                    textTransform: 'uppercase',
                    letterSpacing: 0.8,
                    borderBottom: `2px solid ${S.borderLight}`,
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {SLIDING_SCALE.map((r, i) => (
              <tr key={i} style={{ borderBottom: `1px solid ${S.borderLight}`, background: i % 2 === 0 ? '#fff' : S.bgCard }}>
                <td style={{ padding: '13px 14px', fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{r.lossBand}</td>
                <td style={{ padding: '13px 14px', fontSize: 15, fontWeight: 700, color: S.burgundy }}>{r.commission}%</td>
                <td style={{ padding: '13px 14px' }}>
                  {i === 0 && (
                    <span style={{ padding: '3px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: '#dcfce7', color: '#15803d' }}>{t('screens.commissions.scaleBestRate')}</span>
                  )}
                  {i === SLIDING_SCALE.length - 1 && (
                    <span style={{ padding: '3px 8px', borderRadius: 6, fontSize: 11, fontWeight: 600, background: '#fee2e2', color: '#991b1b' }}>{t('screens.commissions.scaleMinRate')}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div style={{ marginTop: 16 }}>
          <BtnSecondary style={{ width: '100%', justifyContent: 'center' }}>
            <Icon name='edit' color={S.textMuted} size={14} /> {t('screens.commissions.scaleEditConfig')}
          </BtnSecondary>
        </div>
      </DataCard>
    </div>
  );
};

export default SlidingScale;
